import { cloneElement } from "react";
import { Box, Step, StepButton, Stepper, Typography } from "@mui/material";
import { matchPath, Redirect, Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { IStepRoute } from "./IStepRoute";
import { useStyle } from "@common/StepperRouter/style";
import { useDeviceType } from "@hooks/useDeviceType";

interface IParams {
    stepList: IStepRoute[];
}

export const StepperRouter = (props: IParams) => {
    const { stepList } = props;
    const { url } = useRouteMatch();
    const {
        push,
        location: { search, pathname },
    } = useHistory();
    const { classes } = useStyle();
    const { isMobile } = useDeviceType();

    const currentPath = pathname.replace(`${url}/`, "");

    const activeStepIndex = stepList.findIndex((step) => matchPath(currentPath, { path: step.path, exact: true }));
    const activeStep = stepList[activeStepIndex];

    return (
        <>
            <div className={classes.stepperContainer}>
                <Stepper activeStep={activeStepIndex} alternativeLabel={isMobile} className={classes.stepper}>
                    {stepList.map((step, index) => (
                        <Step key={step.label}>
                            <StepButton
                                disabled={Boolean(step.isDisabled) || index > activeStepIndex}
                                onClick={() => push(step.path)}
                            >
                                {step.label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
                {activeStep && !activeStep.hideStepTitle && (
                    <Box marginBottom={2}>
                        <Typography
                            color="primary"
                            paddingBottom={activeStep.subtitle ? 1.5 : 3}
                            paddingTop={3}
                            textAlign={isMobile ? "center" : "start"}
                            variant="h1"
                        >
                            {activeStep.label}
                        </Typography>
                        {activeStep.subtitle && (
                            <Typography
                                color="secondary"
                                gutterBottom
                                marginBottom={5}
                                textAlign={isMobile ? "center" : "start"}
                                variant="large"
                            >
                                {activeStep.subtitle}
                            </Typography>
                        )}
                    </Box>
                )}
            </div>
            <Switch>
                {stepList.map((step, index) => {
                    const prevStep = index === 0 ? undefined : stepList[index - 1];
                    const nextStep = index === stepList.length - 1 ? undefined : stepList[index + 1];

                    return (
                        <Route
                            exact
                            key={step.label}
                            path={step.path}
                            render={() =>
                                step.isValid === undefined || step.isValid ? (
                                    cloneElement(step.component, {
                                        prevStep,
                                        nextStep,
                                    })
                                ) : (
                                    <Redirect to={{ pathname: prevStep?.path, search }} />
                                )
                            }
                        />
                    );
                })}
                <Redirect to={{ pathname: stepList[0].path, search }} />
            </Switch>
        </>
    );
};
